<template>
  <div class="comp-score-board">
    <div class="center-content">
      <div
        class='check-box'
        v-for="key in interactiveData.scoreKeys"
        v-bind:key="key"
      >
        <div
          class="check-box-value"
          v-show="(component[key].completed === true)"
          v-bind:class="(component[key].data.currentScore === component[key].data.totalScore) ? 'correct' : 'wrong'"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { focus } from 'vue-focus'
import { mapState } from 'vuex'

export default {
  name: 'ScoreBoard',
  directives: { focus: focus },
  data () {
    return {
      focused: false,
      isDisplay: false,
      message: ''
    }
  },
  props: {
    displayed: {
      type: Boolean,
      default: true
    },
    isFocus: {
      type: Boolean,
      required: false,
      dafault: false
    }
  },
  computed: {
    ...mapState({
      interactiveData: state => state.interactiveData,
      component: state => state.componentData
    }),
    content () {
      return this.$store.getters.getData(this.dataId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/score-board/ScoreBoard.vue